import { render, staticRenderFns } from "./SuppliesItems.vue?vue&type=template&id=144cf689"
import script from "./SuppliesItems.vue?vue&type=script&lang=js"
export * from "./SuppliesItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports